var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.334 11.334l.166.166c.32.32.5.754.5 1.207V14c0 1.333-.333 2-1 2C7 16 0 9 0 1c0-.667.667-1 2-1h1.293C3.746 0 4.18.18 4.5.5l.166.166a2 2 0 0 1 .483.782l.685 2.055a1 1 0 0 1-.148.916L4.5 6l5.5 5.5 1.58-1.186a1 1 0 0 1 .917-.148l2.055.685a2 2 0 0 1 .782.483z","fill":"currentColor","fillRule":"evenodd"}));
}

PhoneInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
